// ISO 3166-1 alpha-2 country codes and names, used for the region flag picker.
const COUNTRY_CODES: { code: string; name: string }[] = [
  { code: "AD", name: "Andorra" }, { code: "AE", name: "United Arab Emirates" },
  { code: "AF", name: "Afghanistan" }, { code: "AG", name: "Antigua and Barbuda" },
  { code: "AI", name: "Anguilla" }, { code: "AL", name: "Albania" },
  { code: "AM", name: "Armenia" }, { code: "AO", name: "Angola" },
  { code: "AR", name: "Argentina" }, { code: "AT", name: "Austria" },
  { code: "AU", name: "Australia" }, { code: "AW", name: "Aruba" },
  { code: "AZ", name: "Azerbaijan" }, { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BB", name: "Barbados" }, { code: "BD", name: "Bangladesh" },
  { code: "BE", name: "Belgium" }, { code: "BF", name: "Burkina Faso" },
  { code: "BG", name: "Bulgaria" }, { code: "BH", name: "Bahrain" },
  { code: "BI", name: "Burundi" }, { code: "BJ", name: "Benin" },
  { code: "BN", name: "Brunei" }, { code: "BO", name: "Bolivia" },
  { code: "BR", name: "Brazil" }, { code: "BS", name: "Bahamas" },
  { code: "BT", name: "Bhutan" }, { code: "BW", name: "Botswana" },
  { code: "BY", name: "Belarus" }, { code: "BZ", name: "Belize" },
  { code: "CA", name: "Canada" }, { code: "CD", name: "DR Congo" },
  { code: "CF", name: "Central African Republic" }, { code: "CG", name: "Congo" },
  { code: "CH", name: "Switzerland" }, { code: "CI", name: "Ivory Coast" },
  { code: "CL", name: "Chile" }, { code: "CM", name: "Cameroon" },
  { code: "CN", name: "China" }, { code: "CO", name: "Colombia" },
  { code: "CR", name: "Costa Rica" }, { code: "CU", name: "Cuba" },
  { code: "CV", name: "Cape Verde" }, { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" }, { code: "DE", name: "Germany" },
  { code: "DJ", name: "Djibouti" }, { code: "DK", name: "Denmark" },
  { code: "DM", name: "Dominica" }, { code: "DO", name: "Dominican Republic" },
  { code: "DZ", name: "Algeria" }, { code: "EC", name: "Ecuador" },
  { code: "EE", name: "Estonia" }, { code: "EG", name: "Egypt" },
  { code: "ER", name: "Eritrea" }, { code: "ES", name: "Spain" },
  { code: "ET", name: "Ethiopia" }, { code: "FI", name: "Finland" },
  { code: "FJ", name: "Fiji" }, { code: "FR", name: "France" },
  { code: "GA", name: "Gabon" }, { code: "GB", name: "United Kingdom" },
  { code: "GD", name: "Grenada" }, { code: "GE", name: "Georgia" },
  { code: "GH", name: "Ghana" }, { code: "GM", name: "Gambia" },
  { code: "GN", name: "Guinea" }, { code: "GQ", name: "Equatorial Guinea" },
  { code: "GR", name: "Greece" }, { code: "GT", name: "Guatemala" },
  { code: "GW", name: "Guinea-Bissau" }, { code: "GY", name: "Guyana" },
  { code: "HK", name: "Hong Kong" }, { code: "HN", name: "Honduras" },
  { code: "HR", name: "Croatia" }, { code: "HT", name: "Haiti" },
  { code: "HU", name: "Hungary" }, { code: "ID", name: "Indonesia" },
  { code: "IE", name: "Ireland" }, { code: "IL", name: "Israel" },
  { code: "IN", name: "India" }, { code: "IQ", name: "Iraq" },
  { code: "IR", name: "Iran" }, { code: "IS", name: "Iceland" },
  { code: "IT", name: "Italy" }, { code: "JM", name: "Jamaica" },
  { code: "JO", name: "Jordan" }, { code: "JP", name: "Japan" },
  { code: "KE", name: "Kenya" }, { code: "KG", name: "Kyrgyzstan" },
  { code: "KH", name: "Cambodia" }, { code: "KI", name: "Kiribati" },
  { code: "KM", name: "Comoros" }, { code: "KN", name: "Saint Kitts and Nevis" },
  { code: "KP", name: "North Korea" }, { code: "KR", name: "South Korea" },
  { code: "KW", name: "Kuwait" }, { code: "KZ", name: "Kazakhstan" },
  { code: "LA", name: "Laos" }, { code: "LB", name: "Lebanon" },
  { code: "LC", name: "Saint Lucia" }, { code: "LI", name: "Liechtenstein" },
  { code: "LK", name: "Sri Lanka" }, { code: "LR", name: "Liberia" },
  { code: "LS", name: "Lesotho" }, { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" }, { code: "LV", name: "Latvia" },
  { code: "LY", name: "Libya" }, { code: "MA", name: "Morocco" },
  { code: "MC", name: "Monaco" }, { code: "MD", name: "Moldova" },
  { code: "ME", name: "Montenegro" }, { code: "MG", name: "Madagascar" },
  { code: "MH", name: "Marshall Islands" }, { code: "MK", name: "North Macedonia" },
  { code: "ML", name: "Mali" }, { code: "MM", name: "Myanmar" },
  { code: "MN", name: "Mongolia" }, { code: "MR", name: "Mauritania" },
  { code: "MT", name: "Malta" }, { code: "MU", name: "Mauritius" },
  { code: "MV", name: "Maldives" }, { code: "MW", name: "Malawi" },
  { code: "MX", name: "Mexico" }, { code: "MY", name: "Malaysia" },
  { code: "MZ", name: "Mozambique" }, { code: "NA", name: "Namibia" },
  { code: "NE", name: "Niger" }, { code: "NG", name: "Nigeria" },
  { code: "NI", name: "Nicaragua" }, { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" }, { code: "NP", name: "Nepal" },
  { code: "NR", name: "Nauru" }, { code: "NZ", name: "New Zealand" },
  { code: "OM", name: "Oman" }, { code: "PA", name: "Panama" },
  { code: "PE", name: "Peru" }, { code: "PG", name: "Papua New Guinea" },
  { code: "PH", name: "Philippines" }, { code: "PK", name: "Pakistan" },
  { code: "PL", name: "Poland" }, { code: "PT", name: "Portugal" },
  { code: "PW", name: "Palau" }, { code: "PY", name: "Paraguay" },
  { code: "QA", name: "Qatar" }, { code: "RO", name: "Romania" },
  { code: "RS", name: "Serbia" }, { code: "RU", name: "Russia" },
  { code: "RW", name: "Rwanda" }, { code: "SA", name: "Saudi Arabia" },
  { code: "SB", name: "Solomon Islands" }, { code: "SC", name: "Seychelles" },
  { code: "SD", name: "Sudan" }, { code: "SE", name: "Sweden" },
  { code: "SG", name: "Singapore" }, { code: "SI", name: "Slovenia" },
  { code: "SK", name: "Slovakia" }, { code: "SL", name: "Sierra Leone" },
  { code: "SM", name: "San Marino" }, { code: "SN", name: "Senegal" },
  { code: "SO", name: "Somalia" }, { code: "SR", name: "Suriname" },
  { code: "SS", name: "South Sudan" }, { code: "ST", name: "Sao Tome and Principe" },
  { code: "SV", name: "El Salvador" }, { code: "SY", name: "Syria" },
  { code: "SZ", name: "Eswatini" }, { code: "TD", name: "Chad" },
  { code: "TG", name: "Togo" }, { code: "TH", name: "Thailand" },
  { code: "TJ", name: "Tajikistan" }, { code: "TL", name: "Timor-Leste" },
  { code: "TM", name: "Turkmenistan" }, { code: "TN", name: "Tunisia" },
  { code: "TO", name: "Tonga" }, { code: "TR", name: "Turkey" },
  { code: "TT", name: "Trinidad and Tobago" }, { code: "TV", name: "Tuvalu" },
  { code: "TW", name: "Taiwan" }, { code: "TZ", name: "Tanzania" },
  { code: "UA", name: "Ukraine" }, { code: "UG", name: "Uganda" },
  { code: "US", name: "United States" }, { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" }, { code: "VA", name: "Vatican City" },
  { code: "VC", name: "Saint Vincent and the Grenadines" }, { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" }, { code: "VU", name: "Vanuatu" },
  { code: "WS", name: "Samoa" }, { code: "YE", name: "Yemen" },
  { code: "ZA", name: "South Africa" }, { code: "ZM", name: "Zambia" },
  { code: "ZW", name: "Zimbabwe" },
];

function countryCodeToFlag(code: string): string {
  return String.fromCodePoint(...code.toUpperCase().split("").map((c) => 127397 + c.charCodeAt(0)));
}

// Reverses a flag emoji (pair of regional indicator symbols) back to its ISO alpha-2 code.
export function flagToCountryCode(flag: string): string | null {
  const points = Array.from(flag).map((c) => c.codePointAt(0));
  if (points.length !== 2 || points.some((p) => p < 127462 || p > 127487)) return null;
  return points.map((p) => String.fromCharCode(p - 127397)).join("");
}

// Frontend-only label for sites without a stored region; never persisted to the backend.
export const GLOBAL_REGION_LABEL = "Global";

export function parseRegion(region: string): { codes: string[]; name: string } {
  if (!region) return { codes: [], name: GLOBAL_REGION_LABEL };
  const parts = region.trim().split(" ");
  const trailingCodes = flagsToCountryCodes(parts[parts.length - 1]);
  if (trailingCodes) return { codes: trailingCodes, name: parts.slice(0, -1).join(" ") };
  // Regions saved before the format change are stored as "<flags> <name>".
  const leadingCodes = flagsToCountryCodes(parts[0]);
  if (leadingCodes) return { codes: leadingCodes, name: parts.slice(1).join(" ") };
  return { codes: [], name: region };
}

// Reverses a concatenation of flag emojis (e.g. "🇺🇸🇨🇦") into their ISO alpha-2 codes.
// Returns null if the token isn't made up entirely of valid flag emoji pairs.
export function flagsToCountryCodes(token: string): string[] | null {
  const points = Array.from(token).map((c) => c.codePointAt(0));
  if (points.length === 0 || points.length % 2 !== 0) return null;
  const codes: string[] = [];
  for (let i = 0; i < points.length; i += 2) {
    const pair = [points[i], points[i + 1]];
    if (pair.some((p) => p < 127462 || p > 127487)) return null;
    codes.push(pair.map((p) => String.fromCharCode(p - 127397)).join(""));
  }
  return codes;
}

export interface CountryFlag {
  code: string;
  name: string;
  flag: string;
}

export const COUNTRY_FLAGS: CountryFlag[] = COUNTRY_CODES.map((c) => ({
  ...c,
  flag: countryCodeToFlag(c.code),
})).sort((a, b) => a.name.localeCompare(b.name));
